import * as React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Value: 24-hour "HH:mm". UI: 12-hour with explicit AM/PM so users can't accidentally save AM.
export interface Time12PickerProps {
  value: string; // "HH:mm"
  onChange: (v: string) => void;
  className?: string;
}

export function Time12Picker({ value, onChange, className }: Time12PickerProps) {
  const [hh24Str, mmStr] = (value || "00:00").split(":");
  const hh24 = Number(hh24Str) || 0;
  const mm = Number(mmStr) || 0;
  const period: "AM" | "PM" = hh24 >= 12 ? "PM" : "AM";
  const hh12 = ((hh24 + 11) % 12) + 1; // 1..12

  const emit = (h12: number, m: number, p: "AM" | "PM") => {
    let h24 = h12 % 12;
    if (p === "PM") h24 += 12;
    const pad = (n: number) => String(n).padStart(2, "0");
    onChange(`${pad(h24)}:${pad(m)}`);
  };

  return (
    <div className={`grid grid-cols-3 gap-1 ${className ?? ""}`}>
      <Select value={String(hh12)} onValueChange={(v) => emit(Number(v), mm, period)}>
        <SelectTrigger><SelectValue /></SelectTrigger>
        <SelectContent>
          {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
            <SelectItem key={h} value={String(h)}>{h}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={String(mm).padStart(2, "0")} onValueChange={(v) => emit(hh12, Number(v), period)}>
        <SelectTrigger><SelectValue /></SelectTrigger>
        <SelectContent>
          {[0, 15, 30, 45].map((m) => (
            <SelectItem key={m} value={String(m).padStart(2, "0")}>{String(m).padStart(2, "0")}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={period} onValueChange={(v) => emit(hh12, mm, v as "AM" | "PM")}>
        <SelectTrigger><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="AM">AM</SelectItem>
          <SelectItem value="PM">PM</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}